import React from 'react';
import PropTypes from 'prop-types';
import { Add as AddIcon } from '@mui/icons-material'; 
import { CircularProgress, Box } from '@mui/material';
import {
    SidebarWrapper,
    NewWorkflowButton,
    WorkflowList,
    WorkflowListItem,
    StyledListItemText,
    EmptyState,
} from './ChatSidebar.styles';

const formatDate = (dateString) => {
    if (!dateString) return '';
    // Simple date formatting, adjust as needed
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
};

const ChatSidebar = ({
    workflows,
    selectedWorkflowId,
    onSelectWorkflow,
    onNewWorkflow,
    isLoading,
}) => {
    return (
        <SidebarWrapper elevation={1}>
            <NewWorkflowButton
                variant="contained"
                startIcon={<AddIcon />}
                onClick={onNewWorkflow}
                fullWidth
                disabled={isLoading} 
            >
                New Contract Workflow
            </NewWorkflowButton>

            {isLoading && workflows.length === 0 ? (
                <Box display="flex" justifyContent="center" alignItems="center" flexGrow={1}>
                    <CircularProgress size={30} />
                </Box>
            ) : (
                <WorkflowList>
                    {workflows.length === 0 ? (
                        <EmptyState>No contract sessions found.</EmptyState>
                    ) : (
                        workflows.map((workflow) => (
                            <WorkflowListItem
                                key={workflow.id} 
                                selected={workflow.id === selectedWorkflowId}
                                onClick={() => onSelectWorkflow(workflow.id)}
                            >
                                <StyledListItemText
                                    primary={workflow.name || `Workflow ${workflow.id}`} 
                                    secondary={formatDate(workflow.updated_at)} 
                                />
                            </WorkflowListItem>
                        ))
                    )}
                </WorkflowList>
            )}
        </SidebarWrapper>
    );
};

export default ChatSidebar; 